module.exports = __webpack_public_path__ + "img/dash-board.388880d4.svg";